// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectAllResponsibleDealers = dealers => ({
    dealers,
    type: actions.TOGGLE_ALL_RESPONSIBLE_DEALERS
});

export const selectResponsibleDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_RESPONSIBLE_DEALER
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.TOGGLE_ALL_RESPONSIBLE_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/action-creators/select-dealer.js